/** App branding shown in sidebar, navbar, login, and document title. */
export const APP_NAME = 'SEO Tools';
